import apiClient from 'services/axios'

const BASE_URL = 'reservation'
const BASE_URL_2 = 'online-ordering'

export async function reservationSetup(businessSlug) {
  return apiClient
    .get(`${BASE_URL}/info/${businessSlug}`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function getTimeSlot(businessId, payload) {
  return apiClient
    .post(`${BASE_URL}/timing?business=${businessId}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function sendOTP(businessId, phone_number, country) {
  return apiClient
    .post(`${BASE_URL_2}/send-otp?business=${businessId}`, { phone_number, country })
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function resendOTP(businessId, phone_number, country) {
  return apiClient
    .post(`${BASE_URL_2}/resend-otp?business=${businessId}`, { phone_number, country })
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function addReservation(businessId, payload) {
  return apiClient
    .post(`${BASE_URL}/book?business=${businessId}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function getDeviceInfo(device_id) {
  let query = ''
  if (device_id) {
    query = `?customer_device_id=${device_id}`
  }
  return apiClient
    .get(`${BASE_URL_2}/customer${query}`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function verifyOTP(businessId, payload) {
  return apiClient
    .post(`${BASE_URL_2}/verify-otp?business=${businessId}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function updateCustomer(businessId, payload) {
  return apiClient
    .put(`${BASE_URL_2}/customer?business=${businessId}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}